import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=ae7b767a&scoped=true"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"
import style0 from "./Alerts.vue?vue&type=style&index=0&id=ae7b767a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7b767a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae7b767a')) {
      api.createRecord('ae7b767a', component.options)
    } else {
      api.reload('ae7b767a', component.options)
    }
    module.hot.accept("./Alerts.vue?vue&type=template&id=ae7b767a&scoped=true", function () {
      api.rerender('ae7b767a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overlays/Alerts.vue"
export default component.exports